// Best-effort extraction of card/decline info from a raw CheckoutChamp order
// object. Field names haven't been confirmed against a live account yet, so
// this tries a handful of plausible keys per piece of info and returns null
// for anything it can't find — callers should always show the raw order JSON
// as a fallback rather than relying solely on this.
function pick(order: Record<string, unknown>, keys: string[]): string | null {
  for (const key of keys) {
    const value = order[key];
    if (value !== undefined && value !== null && value !== "") {
      return String(value);
    }
  }
  return null;
}

export interface DeclinedCardInfo {
  last4: string | null;
  cardType: string | null;
  declineReason: string | null;
  orderStatus: string | null;
}

export function extractDeclinedCardInfo(order: Record<string, unknown>): DeclinedCardInfo {
  return {
    last4: pick(order, [
      "cardLast4",
      "last4",
      "ccLast4",
      "cardNumberLast4",
      "maskedCardNumber",
    ]),
    cardType: pick(order, ["cardType", "ccType", "cardBrand", "paymentMethod"]),
    declineReason: pick(order, [
      "declineReason",
      "responseText",
      "responseMessage",
      "gatewayResponse",
      "authResponseText",
    ]),
    orderStatus: pick(order, ["orderStatus"]),
  };
}
